import React from "react";

import { IoChevronBackOutline } from "react-icons/io5";
import { Nav } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import Logo from "../../common/images/logo.png";
import { PALETTE } from "../../common/ThemeConstants";
import { useWindowWidth } from "../../api/useWindowWidth";
import { NavbarResponsive } from "../../common/components/NavbarResponsive";

export default function ExerciseHeader({
  title,
  showInfo,
  info = "",
  backTo = undefined,
}) {
  const { idExercise } = useParams();
  const width = useWindowWidth();
  const navigate = useNavigate();

  const abbreviateTitle =
    width < 768 && title.length > 20 ? title.slice(0, 20) + "..." : title;

  return (
    <NavbarResponsive showBackground={false}>
      <Container>
        <Navbar.Brand>
          <div
            className="align-self-center flex back-button"
            style={{ width: 70 }}
          >
            <IoChevronBackOutline
              onClick={() => {
                backTo === undefined ? navigate(-1) : navigate(backTo);
              }}
              size={24}
              style={{ cursor: "pointer" }}
              color={PALETTE.TRUEGRAY}
            />
          </div>
        </Navbar.Brand>
        <Nav style={{ textDecoration: "none" }}>
          <div className="text-center">
            <p style={{ color: PALETTE.DARK, fontSize: 17, margin: 0 }}>
              {abbreviateTitle}
            </p>
          </div>
        </Nav>
        <div style={{ marginLeft: "1rem" }}>
          <div className="align-self-center" style={{ width: 70 }}>
            <img
              src={Logo}
              style={{ width: "100%" }}
              alt="Federico Bartoli PT"
            />
          </div>
        </div>
      </Container>
    </NavbarResponsive>
  );
}
